// @flow

import _ from 'lodash';
import { JSable } from 'jsable';
import vb from 'validation-builder';
import { ValidatableMixin } from 'validatable';
import ko from 'rgs-knockout';
import type { Observable, ObservableArray, PureComputed } from 'rgs-knockout';

import { withProps } from '../helpers';
import { TemporaryFileInfo } from 'temporary-file-info';

export type TUploadFileProps = {
	mimeTypes: string[],
	maxFilesCount: number | Observable<number>,
	maxFilesCountError: string,
	files: ObservableArray<>,
	buttonTitle: string,
	isRequired: boolean,
	fileMaxSizeMb: number,
	isFetching: Observable<boolean>,
	doAfterTempUpload?: (files: TemporaryFileInfo)=>any,
	multiple?: boolean,
	filesFormat: string,
};

export type TUploadFileOptions = {
	props: TUploadFileProps,
};

const DEFAULT_VALUES = {
	maxFilesCount: 1,
	fileMaxSizeMb: 10,
	isRequired: true,
	buttonTitle: 'Прикрепите файл',
	multiple: true,
};

export default class UploadFileViewModel extends ValidatableMixin(JSable) {
	props: TUploadFileProps;
	files: ObservableArray<*>;
	isShowBtnUploadFile: PureComputed<boolean>;

	constructor (options: TUploadFileOptions) {
		super();

		const {
			maxFilesCount,
			maxFilesCountError,
			files,
			buttonTitle,
			isRequired,
			fileMaxSizeMb,
			isFetching,
			mimeTypes,
			doAfterTempUpload,
			multiple,
			filesFormat,
		} = withProps(options);

		this.props = {
			maxFilesCount,
			maxFilesCountError,
			files,
			buttonTitle,
			isRequired,
			fileMaxSizeMb,
			isFetching,
			mimeTypes,
			doAfterTempUpload,
			multiple,
			filesFormat,
		};

		this.files = this.props.files.extend({
			validation: vb.all([
				vb.if(
					() => this.props.isRequired === undefined
						? DEFAULT_VALUES.isRequired
						: this.props.isRequired,
					vb.required(true, 'Выберите файл')
				),
				vb.totalFileMaxSize(
					`${this.props.fileMaxSizeMb || DEFAULT_VALUES.fileMaxSizeMb}mb`,
				),
				vb.universalFileUploadFulfilled(),
				_.isFunction(this.props.maxFilesCount)
					? vb.custom(v => v.length <= this.props.maxFilesCount(),
					maxFilesCountError || `не более ${this.props.maxFilesCount()} ${
						this.props.maxFilesCount() === 1
							? 'файла' : 'файлов'}`)
					: vb.custom(v => v.length <= this.props.maxFilesCount,
					maxFilesCountError || `не более ${this.props.maxFilesCount} ${
						this.props.maxFilesCount === 1
							? 'файла' : 'файлов'}`),
			]),
		});

		this.isFetching = this.props.isFetching;
		this.buttonTitle = this.props.buttonTitle || DEFAULT_VALUES.buttonTitle;
		this.multiple = this.props.multiple || DEFAULT_VALUES.multiple;

		this.isShowBtnUploadFile = ko.pureComputed(() => {
			if (_.isFunction(this.props.maxFilesCount) && this.props.maxFilesCount() > 0) {
				return this.files().length < this.props.maxFilesCount();
			}
			if (!_.isFunction(this.props.maxFilesCount) && this.props.maxFilesCount > 0) {
				return this.files().length < this.props.maxFilesCount;
			}
			return true;
		});

		this.props.isShowBtnUploadFile = this.isShowBtnUploadFile;
	}
}
